




















































































































import { Component, Vue } from 'vue-property-decorator';
import Card from "@/views/pages/index/card.vue";

@Component({
  components: {
    Card
  },
})

export default class Home extends Vue {
  path = "assets/index/";

  //banner图片的长宽比，用来设置轮播图组件的高度自适应
  bannerImgProportion = 611/1920;
  imgHeight= '';
  carouselImg=[
    {src:require( '@/'+this.path+'banner1.jpg'),url:'/download'},
    {src:require( '@/'+this.path+'banner2.jpg'),href:"https://web.zijinchangxiu.com/#/user/login",target:"_blank"},
    {src:require( '@/'+this.path+'banner3.jpg'),href:"https://web.zijinchangxiu.com/#/user/login",target:"_blank"},
  ];
  intervalTime = 5000;

  //核心功能相关参数
  functionContent=[
    {name:"工单管理",src:require('@/'+this.path+"gongdan.png"),offset:2,
      text:"售后服务的核心引擎，多渠道客户报修、快速受理、智能派单，高效协同，多种模式支持公司的多业务发展"},
    {name:"设备管理",src:require('@/'+this.path+"shebei.png"),offset:1,
      text:"售后服务的重要资源，完善的设备信息，服务记录，通过预防维护及服务计划，确保设备稳健运行"},
    {name:"备件管理",src:require('@/'+this.path+"beijian.png"),offset:1,
      text:"有效的对仓库和备件进行管理，实时掌握备件流向，降低企业仓储成本"},
    {name:"客户管理",src:require('@/'+this.path+"kehuguanli.png"),offset:2,
      text:"服务商档案、服务请求、服务进展、服务评价等"},
    {name:"统计分析",src:require('@/'+this.path+"tongji.png"),offset:1,
      text:"工单、备件、设备多维度数据分析，可视化决策"},
  ];

  //核心优势的背景图片相关参数
  bgImg=require('@/'+this.path+'strengthBackground.png');
  bgHeight='';
  // strengthBgProportion = 714/1920;
  strengthContent = [
    {number:1,title:"悠久的行业发展历史",text:"近30年的售后经验，对售后服务体系有深刻理解"},
    {number:2,title:"卓越的服务网络",text:"350+家服务站点覆盖全国大中小型城市。2500+人的售后团队正在使用畅修平台"},
    {number:3,title:"专业的平台整合能力",text:"提供跨区域、跨行业多种资源共享整合，实现拓宽进货和销售渠道，成为客户与企业的桥梁"},
    {number:4,title:"超高的客户满意度",text:"丰富的服务经验，精通于智能设备领域的维保服务，获得多家银行及众多设备厂商高度认可"},
    {number:5,title:"持续的研发创新能力",text:"专业的软件开发团队，在售后服务软件领域精耕细作多年，产品质量名列前茅"},
  ];

  //服务内容相关参数
  serviceCard=[
    {name:"SaaS应用",src:require('@/'+this.path+"saas.png"),class:"cardFirst"},
    {name:"安装调试",src:require('@/'+this.path+"anzhuang.png"),class:"cardNotFirst"},
    {name:"维修保养",src:require('@/'+this.path+"weixiu.png"),class:"cardNotFirst"},
    {name:"巡检升级",src:require('@/'+this.path+"xunjian.png"),class:"cardNotFirst"},
    {name:"技能培训",src:require('@/'+this.path+"peixun2.png"),class:"cardNotFirst"},
    {name:"技术支持",src:require('@/'+this.path+"jishu2.png"),class:"cardNotFirst"},
    {name:"客户服务",src:require('@/'+this.path+"kehufuwu.png"),class:"cardNotFirst"},
  ];

  cardHeight='';
  cardProportion = 1/12;

  //网点分布相关参数
  src=require( '@/assets/index/map.png');

  //合作伙伴相关参数
  partnerCorp=[
    {src:require('@/'+this.path+"brand1.png"),class:"corpFirst"},
    {src:require('@/'+this.path+"brand2.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand3.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand4.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand5.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand6.png"),class:"corpFirst"},
    {src:require('@/'+this.path+"brand7.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand8.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand9.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand10.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand11.png"),class:"corpFirst"},
    {src:require('@/'+this.path+"brand12.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand13.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand14.png"),class:"corpNotFirst"},
    {src:require('@/'+this.path+"brand15.png"),class:"corpNotFirst"},
  ];



  mounted() {
    this.imgHeight = document.body.clientWidth * this.bannerImgProportion + 'px';
    this.cardHeight = 1200*this.cardProportion + 'px';
    let that = this;
    window.onresize = function windowResize() {
      // 通过捕获系统的onresize事件触发轮播图高度自适应
      that.imgHeight=that.imgHeightChange(that.bannerImgProportion);
      // //触发核心优势板块背景图片高度自适应
      // that.bgHeight=that.imgHeightChange(that.strengthBgProportion);
    }
  }

  imgHeightChange(proportion: number){
    let wid = document.body.clientWidth
    let hei = 826
    if (wid > 1920) {
      hei = 826
    } else {
      hei = proportion * wid
    }
    let height = hei + 'px';
    return height;
  }

  handleClick(item: any){
    this.$router.push(item.url);
  }
}
